import React, { useState } from "react";
import { useUserLogin } from "../components/hooks/useUserLogin";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";
import Credits from "./Credits";
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const {
    username,
    setUsername,
    password,
    setPassword,
    error,
    handleLogin,
  } = useUserLogin();
  
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const success = await handleLogin(e);
      if (success) {
        navigate('/'); // Navigate to home page after successful login
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Zar Mance Portal</h1>
          <p className="login-subtitle">Dobrodošli nazad! Prijavite se na svoj nalog.</p>
        </div>

        {error && (
          <div className="error-alert" role="alert">
            <span className="error-icon">⚠️</span>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-field">
            <div className="input-group">
              <FaUser className="field-icon" />
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Korisničko ime"
                aria-label="Korisničko ime"
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="form-field">
            <div className="input-group">
              <FaLock className="field-icon" />
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Šifra"
                aria-label="Šifra"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Sakrij šifru" : "Prikaži šifru"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className={`submit-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading-spinner" />
            ) : (
              "Prijavi se"
            )}
          </button>
        </form>

        <Credits />
      </div>
    </div>
  );
};

export default Login;
